import { AnyAction, Reducer } from 'redux';

export const STORE_PAIDINVOICE_DATA = 'store/paidinvoice-data';
export const STORE_MYINVOICES_DATA = 'store/myinvoices-data';

export interface PaidInvoiceData {
    rowno: string;
    receiptno: string;
    createdon: string;
    paydate: string;
    refno: string;
    paymode: string;
    paidamt: string;
}
export interface MyInvoicesData {
    rowno: string;
    transid: string;
    docid: string;
    docdate: string;
    customername: string;
    customercode: string;
    accountname: string;
    currency: string;
    exrate: string;
    orderno: string;
    service_name: string;
    tattype: string;
    totunit: string;
    totamount: string;
    totdiscamount: string;
    totalinvamount: string;
    round_off: string;
    totalnetamount: string;
    doctype: string;
}
// export interface PaidInvoiceData {
//     rowno: string;
//     custcode: string;
//     invoiceno: string;
//     invoicedate: string;
//     currency: string;
//     invamount: string;
//     settled: string;
//     outstanding: string;
//     column1: string;
//     duedate: string;
//     orderno: string;
//     service_name: string;
//     tattype: string;
//     totunits: string;
// }

export interface PaidInvoiceState {
    getPaidInvoiceData: PaidInvoiceData[];
    myInvoicesData: MyInvoicesData[];
}

const initialState: PaidInvoiceState = {
    getPaidInvoiceData: [],
    myInvoicesData: []
};

const reducer: Reducer<PaidInvoiceState> = (state: PaidInvoiceState = initialState, action: AnyAction): PaidInvoiceState => {
    switch (action.type) {
        case STORE_PAIDINVOICE_DATA:
            return {
                ...state,
                getPaidInvoiceData: action.getPaidInvoiceData
            };
        case STORE_MYINVOICES_DATA:
            return {
                ...state,
                myInvoicesData: action.myInvoicesData
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/paidinvoice.tsx